import { Injectable } from '@angular/core';
import { IDiagnosticsService } from './interfaces';

/**
 * A base type for registry implementations. Represents a registry of RESTful
 * endpoints used by applcation.
 */
@Injectable({
  providedIn: 'root'
})
export abstract class GraphResourceRegistry {
  protected readonly abstract registry: any;

  constructor(protected diagnostics: IDiagnosticsService) {}

  /**
   * Given a key finds a URL or a URL template in the registry,
   * applies parameters and formatting as necessary, and returns
   * a ready-to-call RESTful URL.
   * @param key - key, by which to to identify URL or template in the registry.
   * @param args - optional array of parameters to apply to a URL template.
   */
  public getUrl(key: string, args?: any[]): string {
    if (this.registry.hasOwnProperty(key)) {
      if (args && args.length > 0) {
        const template = this.registry[key] as string;
        const url = this.format(template, args);
        return url;
      } else {
        return this.registry[key] as string;
      }
    } else {
      this.diagnostics.logError(`Key ${key} was not found in resource registry.`);
      return null;
    }
  }

  private format (template: string, args: any[]) {
    let formattedString = template;

    for (let i = 0; i < args.length; i++) {
        const regex = new RegExp('\\{' + i + '\\}', 'gm');
        formattedString = formattedString.replace(regex, args[i]);
    }

    return formattedString;
  }
}
